import { createStoreWrapper } from "@landtechnologies/drawings-frontend";
import { proxy } from "valtio/vanilla";

export type DrawingStore = {
  // eslint-disable-next-line no-undef
  reduxStore?: null | ReturnType<typeof createStoreWrapper>;
  currentWorkspaceId?: string | null;
  drawingsOverlay?: google.maps.MapType | null;
  map?: google.maps.Map | null;
  destroy: () => void;
};

export const drawingStore = proxy<DrawingStore>({
  currentWorkspaceId: null,
  reduxStore: null,
  drawingsOverlay: null,
  map: null,
  destroy: function (this: DrawingStore) {
    if (this.currentWorkspaceId && this.reduxStore) {
      this.reduxStore.destroy();
    }
  },
});
